import React from 'react';
import utils from '../../../../../services/utils';
import Button from '../../../../Buttons/Button/Button';
import FieldBold from '../../../../Fields/FieldBold/FieldBold';
import Tags from '../../../../Tags/Tags';

import classes from './InvoiceCard.module.scss';

const InvoiceCard = ({ purchases, onClick }) => {
  return (
    <div className={classes.card}>
      <div className={classes['space-between']}>
        <span className={`${classes.color} medium-16`}>{purchases.description}</span>
        <Tags
          type={purchases.totalValueWasPayed ? 'green' : 'gray'}
          text={purchases.totalValueWasPayed ? 'Pago total' : 'Pago parcial'}
        />
      </div>
      <div className={`${classes['space-between']} ${classes.total}`}>
        <FieldBold title='TOTAL A PAGAR' value={utils.moneyFormat(purchases.payedValue)} />
        <Button onClick={() => onClick(purchases)} custom='quaternary'>
          Ver detalles
        </Button>
      </div>
    </div>
  );
};

export default InvoiceCard;
